import { InteractionScreen } from "../../../Redux/screenInteractionsSlice";
import { AboutScreen } from "../../Screen/ScreenInteractions/AboutScreen";
import { DemoSelectScreen } from "../../Screen/ScreenInteractions/DemoSelectScreen";
import { Game } from "../../Screen/ScreenInteractions/Game";
import { HomeScreen } from "../../Screen/ScreenInteractions/HomeScreen";
import { LinksScreen } from "../../Screen/ScreenInteractions/LinksScreen";
import { SandboxScreen } from "../../Screen/ScreenInteractions/SandboxScreen";
import { WelcomeScreen } from "../../Screen/ScreenInteractions/WelcomeScreen";

interface IProps {
    interactionScreen: InteractionScreen
}

export const ScreenResolver: React.FC<IProps> = ({ interactionScreen }) => {
    switch (interactionScreen) {
        case InteractionScreen.WELCOME:
            return <WelcomeScreen />
        case InteractionScreen.HOME:
            return <HomeScreen />;
        case InteractionScreen.GAME:
            return <Game />;
        case InteractionScreen.ABOUT:
            return <AboutScreen />;
        case InteractionScreen.LINKS:
            return <LinksScreen />;
        case InteractionScreen.DEMO_SELECT:
            return <DemoSelectScreen />;
        case InteractionScreen.ROADMAP:
        case InteractionScreen.OPTIONS:
            // return <OptionsScreen/>;
            return <></>;
        case InteractionScreen.SANDBOX:
            return <SandboxScreen />;
        default:
            return <></>;
    }
}